import * as yup from 'yup';
import { CTAGroup } from '@web/components';
import { schema as ctaButtonSchema } from './cta_button';

export const component = CTAGroup;

export const schema = yup
  .object({
    component: yup.string(),
    ctas: yup.array(ctaButtonSchema),
    buttonsPerRow: yup.number().nullable(),
  })
  .transform(value => ({
    component: 'cta_group',
    ctas: value.ctas || [],
    buttonsPerRow: value.buttons_per_row || undefined,
  }));
